import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window back to the top on every route change, so a freshly
 * opened page never inherits the previous page's scroll position — the
 * standard SPA behaviour.
 *
 * Keyed on `pathname` only (not search/hash), so in-page anchor links
 * (e.g. "#section") and query-string updates don't force a jump to the top.
 * Renders nothing.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Instant jump (not smooth) — navigation should feel immediate.
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
